---
title: Best Fishing Notes App
description: Why simple fishing notes outperform complex systems.
---

# Best Fishing Notes App

Fishing notes work when they’re honest and quick.

## Good notes capture
- What you tried
- What you noticed
- What surprised you

## Bad notes try to predict
Fishing isn’t a spreadsheet problem.

Roddo keeps notes lightweight so you’ll actually write them.

If you’re new, start with the
[beginner fishing tips](/learn/beginner-fishing-tips).

---
### Keep learning
- [Fishing techniques](/learn/techniques)
- [Species guides](/learn/species)
- [Fishing regions](/learn/regions)
- [Roddo Learn hub](/learn)
